import { GOOGLE_FONTS_RANGES } from "@excalidraw/common";

import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import OrbitronRegular from "./Orbitron-Regular.woff2";

export const OrbitronFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: OrbitronRegular,
    descriptors: { unicodeRange: GOOGLE_FONTS_RANGES.LATIN },
  },
];
